import React from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  Button,
  Chip,
} from '@mui/material';
import {
  Person as PersonIcon,
  Badge as BadgeIcon,
  Fingerprint as FingerprintIcon,
  Receipt as ReceiptIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
  Visibility as VisibilityIcon,
  PersonSearch as PersonSearchIcon,
} from '@mui/icons-material';
import { useHistory } from 'react-router-dom';

export default function TPosiblesClientes(props) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const rows = props.rows;
  const termc = props.termc;
  const history = useHistory();

  const seleccionar = (cliente) => {
    history.push({ pathname: '/posibleClientePerfil', state: cliente });
  };

  function searchingTermc(termc) {
    return function (x) {
      const nombre = x.nombre || '';
      const apellido = x.apellido || '';
      const ci = x.ci || '';
      const ruc = x.ruc || '';

      return (
        nombre.toUpperCase().includes(termc.toUpperCase()) ||
        apellido.toUpperCase().includes(termc.toUpperCase()) ||
        ci.toUpperCase().includes(termc.toUpperCase()) ||
        ruc.toUpperCase().includes(termc.toUpperCase()) ||
        !termc
      );
    };
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const filteredRows = (rows || []).filter(searchingTermc(termc));
  const paginatedRows = filteredRows.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <Box sx={{ width: '100%' }}>
      <TableContainer sx={{ maxHeight: 600 }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  borderBottom: 2,
                  borderColor: 'primary.main',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                }}
              >
                Nombre
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  borderBottom: 2,
                  borderColor: 'primary.main',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                }}
              >
                Apellido/Razón Social
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  borderBottom: 2,
                  borderColor: 'primary.main',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                }}
              >
                CI
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  borderBottom: 2,
                  borderColor: 'primary.main',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                }}
              >
                RUC
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  borderBottom: 2,
                  borderColor: 'primary.main',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                }}
              >
                Teléfono
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  borderBottom: 2,
                  borderColor: 'primary.main',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                }}
              >
                Email
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  borderBottom: 2,
                  borderColor: 'primary.main',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                }}
              >
                Acciones
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedRows.length > 0 ? (
              paginatedRows.map((cliente) => (
                <TableRow
                  key={cliente.posibleclientE_Id}
                  hover
                  sx={{
                    '&:hover': {
                      backgroundColor: '#f5f5f5',
                    },
                    '&:nth-of-type(even)': {
                      backgroundColor: 'action.hover',
                    },
                  }}
                >
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <PersonIcon sx={{ fontSize: 20, color: 'action.active' }} />
                      <Typography variant="body2" sx={{ fontWeight: 500 }}>
                        {cliente.nombre || '—'}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <BadgeIcon sx={{ fontSize: 20, color: 'action.active' }} />
                      <Typography variant="body2">
                        {cliente.apellido || '—'}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                    {cliente.ci ? (
                      <Chip
                        icon={<FingerprintIcon />}
                        label={cliente.ci}
                        size="small"
                        variant="outlined"
                        color="primary"
                      />
                    ) : (
                      <Typography variant="body2" color="text.secondary">
                        —
                      </Typography>
                    )}
                  </TableCell>
                  <TableCell>
                    {cliente.ruc ? (
                      <Chip
                        icon={<ReceiptIcon />}
                        label={cliente.ruc}
                        size="small"
                        variant="outlined"
                        color="secondary"
                      />
                    ) : (
                      <Typography variant="body2" color="text.secondary">
                        —
                      </Typography>
                    )}
                  </TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <PhoneIcon sx={{ fontSize: 18, color: 'action.active' }} />
                      <Typography variant="body2" sx={{ fontFamily: 'monospace' }}>
                        {cliente.telefono || '—'}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <EmailIcon sx={{ fontSize: 18, color: 'action.active' }} />
                      <Typography variant="body2">
                        {cliente.email || '—'}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Button
                      variant="contained"
                      size="small"
                      startIcon={<VisibilityIcon />}
                      onClick={() => seleccionar(cliente)}
                      sx={{
                        textTransform: 'none',
                        fontWeight: 600,
                        fontSize: '0.75rem',
                        px: 1.5,
                        borderRadius: 1.5,
                        boxShadow: 1,
                        '&:hover': {
                          boxShadow: 3,
                          transform: 'translateY(-1px)',
                        },
                        transition: 'all 0.2s ease',
                      }}
                    >
                      Perfil
                    </Button>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={7} align="center" sx={{ py: 8 }}>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      gap: 2,
                      color: 'text.secondary',
                    }}
                  >
                    <PersonSearchIcon sx={{ fontSize: 64, opacity: 0.3 }} />
                    <Typography variant="h6">
                      No se encontraron posibles clientes
                    </Typography>
                    <Typography variant="body2">
                      {termc
                        ? 'Intenta con otros términos de búsqueda'
                        : 'Aún no hay posibles clientes registrados'}
                    </Typography>
                  </Box>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 50, 100]}
        component="div"
        count={filteredRows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        labelRowsPerPage="Filas por página:"
        labelDisplayedRows={({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`
        }
        sx={{
          borderTop: 1,
          borderColor: 'divider',
          '.MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows': {
            fontWeight: 500,
          },
        }}
      />
    </Box>
  );
}
